import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  attPermission: true,
};

const attPermissionSlice = createSlice({
  name: 'attPermission',
  initialState,
  reducers: {
    setATTPermission: (state, action) => {
      const { attPermission } = action.payload;
      state.attPermission = attPermission;
    },
  },
});

export const { setATTPermission } = attPermissionSlice.actions;

export default attPermissionSlice.reducer;
